// extracted by mini-css-extract-plugin
export default {"staffSection":"staffSection_staffSection__yByan","staffGrid":"staffSection_staffGrid__U9liH"};